import { useLayoutEffect, useRef } from "react";

export function useObserveElementSize(observedElement: HTMLElement | null, onSizeChange: (elementSize: ElementSize) => void, onCleanup?: () => void) {
    const onSizeChangeRef = useRef(onSizeChange);
    onSizeChangeRef.current = onSizeChange;

    const onCleanupRef = useRef(onCleanup);
    onCleanupRef.current = onCleanup;

    useLayoutEffect(() => {
        if (!observedElement) return;

        const observerCallback: ResizeObserverCallback = () => {
            onSizeChangeRef.current({
                width: observedElement.offsetWidth,
                height: observedElement.offsetHeight,
                element: observedElement,
            });
        };

        const resizeObserver = new ResizeObserver(observerCallback);
        resizeObserver.observe(observedElement);

        return () => {
            resizeObserver.disconnect();
            onCleanupRef.current?.();
        };
    }, [observedElement]);
}

interface ElementSize {
    width: number;
    height: number;
    element: HTMLElement;
}
